import React from 'react';
import UploadBanner from '../UploadBanner';
import AnalysisPanels from './AnalysisPanels';
import EditorPanel from './EditorPanel';
import RenderStatusPanels from './RenderStatusPanels';
import EditedResultPanel from './EditedResultPanel';
import SourceUploadPanel from './SourceUploadPanel';

// Flag-off rendering. Identical composition/order/DOM to the pre-flag
// ProjectView body — parity is enforced by construction: props flow
// straight through to the same panel components with no branching.
const ProjectLegacyLayout = (props) => {
    const {
        currentProject,
        isAnalysisPending,
        localVideoMeta,
        uploading,
        uploadProgress,
        onFileChange,
        analysisEta,
        generationEta,
        stoppingTask,
        onStopClick,
        projectId,
        videoUrl,
        editedVideoUrl,
        videoPlayerRef,
        progressRef,
        onSourcePlay,
        onEditedPlay,
        onRecalculate,
        isRecalculating,
        editedDurationSeconds,
        editedDurationPending,
        pacedClipCount,
        calculateEditedDuration,
        estimateCreditCost,
        credits,
        isCreating,
        onCreateVideo,
        entitlements,
        editDraft,
        onEditDraftChange,
    } = props;

    if (currentProject.video || isAnalysisPending) {
        return (
            <div>
                <UploadBanner project={currentProject} state="uploaded" localVideoMeta={localVideoMeta} />
                <AnalysisPanels
                    currentProject={currentProject}
                    isAnalysisPending={isAnalysisPending}
                    analysisEta={analysisEta}
                    stoppingTask={stoppingTask}
                    onStopClick={onStopClick}
                    projectId={projectId}
                />
                {(currentProject.video?.status === 'analyzed' || currentProject.video?.status === 'complete') &&
                    <div>
                        <EditorPanel
                            currentProject={currentProject}
                            videoUrl={videoUrl}
                            videoPlayerRef={videoPlayerRef}
                            onSourcePlay={onSourcePlay}
                            onRecalculate={onRecalculate}
                            isRecalculating={isRecalculating}
                            editedDurationSeconds={editedDurationSeconds}
                            editedDurationPending={editedDurationPending}
                            pacedClipCount={pacedClipCount}
                            calculateEditedDuration={calculateEditedDuration}
                            estimateCreditCost={estimateCreditCost}
                            credits={credits}
                            isCreating={isCreating}
                            onCreateVideo={onCreateVideo}
                            projectId={projectId}
                            entitlements={entitlements}
                            editDraft={editDraft}
                            onEditDraftChange={onEditDraftChange}
                        />
                        <RenderStatusPanels
                            currentProject={currentProject}
                            generationEta={generationEta}
                            stoppingTask={stoppingTask}
                            onStopClick={onStopClick}
                            progressRef={progressRef}
                        />
                        <EditedResultPanel
                            currentProject={currentProject}
                            editedVideoUrl={editedVideoUrl}
                            onEditedPlay={onEditedPlay}
                            projectId={projectId}
                        />
                    </div>
                }
            </div>
        );
    }
    return (
        <SourceUploadPanel
            uploading={uploading}
            uploadProgress={uploadProgress}
            onFileChange={onFileChange}
        />
    );
};

export default ProjectLegacyLayout;
